import {useEffect, useState} from "react";

export  const useExitPrompt= (preventEnable:boolean)=> {
    const [showExitPrompt, setShowExitPrompt] = useState(preventEnable);

    window.onload = function () {
        initBeforeUnLoad(showExitPrompt);
    };

    useEffect(() => {
        initBeforeUnLoad(showExitPrompt);
    }, [showExitPrompt]);

    return [showExitPrompt, setShowExitPrompt];
}

const initBeforeUnLoad = (showExitPrompt:boolean) => {
    window.onbeforeunload = (event) => {
        if (showExitPrompt) {
            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = "";
            }
            return "";
        }
    };
};

